import { ApolloClient, ApolloLink, HttpLink, InMemoryCache } from "@apollo/client";

import authLink from "../auth/authLink";

export default new ApolloClient(
    {
        cache: new InMemoryCache(),
        link: ApolloLink.from([authLink(), new HttpLink({ uri: "https://api.bimproject.cloud/graphql" })]),
    },
);
